import { DataType } from '@mode-switch/express';
import { Encoding } from '@mode-vegas/vegas';
import * as angular from 'angular';

import { SelectedChartService } from '@mode/charts/contract';
import { OrganizationResource } from '@mode/legacy/data-access-model-js';
import { ChartTypes, FlamingoTypes } from '@mode/shared/contract-common';
import { getFirstFieldInChannel } from '../../../../lib/chart-encoding-helpers';

export type XFormatType = 'NONE' | 'NUMBER' | 'DATE' | 'MONTH' | 'WEEKDAY' | 'HOUR' | 'MINUTE' | 'SECOND';

class BigValueFormatController implements angular.IController {
  static $inject = [];
  model: FlamingoTypes.ModeModel;
  viewName: string;

  trendFieldFormat: ChartTypes.FieldFormat;
  valueFieldFormat: ChartTypes.FieldFormat;

  format: ChartTypes.ChartFormat;
  encoding: Encoding;

  readOnly: boolean;
  chartService: SelectedChartService;
  owner: OrganizationResource;
  dataType = DataType.Name.Decimal;

  // Local format properties for binding
  trendLabel: string;

  constructor() {}

  $onChanges(changes: angular.IOnChangesObject) {
    if (!this.format) {
      return;
    }

    if (changes.format) {
      this.trendLabel = this.format.bigValue.primaryTrendFormat.label;
    }
  }

  updateTrendLabel() {
    this.chartService.updateBigValueTrendLabel(this.trendLabel);
  }

  updateValueFormat(format: ChartTypes.TextFormat) {
    this.chartService.updateTextFormat(this.valueFormula, ChartTypes.FieldPaneTypes.Default, {
      shortcutType: ChartTypes.FormatShortcutType.Custom,
      ...format,
    });
  }

  updateTrendFormat(format: ChartTypes.TextFormat) {
    this.chartService.updateTextFormat(this.trendFormula, ChartTypes.FieldPaneTypes.Default, {
      shortcutType: ChartTypes.FormatShortcutType.Custom,
      ...format,
    });
  }

  get valueFormula() {
    const field = getFirstFieldInChannel(this.encoding, 'text');
    return field != null ? field.formula : undefined;
  }

  get trendFormula() {
    const field = getFirstFieldInChannel(this.encoding, 'detail');
    return field != null ? field.formula : undefined;
  }
}

export const BigValueFormatComponent: angular.IComponentOptions = {
  bindings: {
    encoding: '<',
    format: '<',
    valueTextFormat: '<',
    trendTextFormat: '<',
    chartService: '<',
  },
  controller: BigValueFormatController,
  controllerAs: 'ctrl',

  template: `
    <div class="settings-group" ng-if="ctrl.valueFormula == null">
      <div class="form-field">Add a field to the <strong>Value</strong> dropzone to enable formatting options</div>
    </div>
    <div class="settings-group" ng-if="ctrl.valueFormula != null">
      <h3 class="setting-title no-border-top">Value</h3>
      <text-format-panel
        field-type="'${DataType.Name.Decimal}'"
        text-format="ctrl.valueTextFormat"
        chart-service="ctrl.chartService"
        format-changed="ctrl.updateValueFormat($format)"
        hide-disabled="true"
      ></text-format-panel>
    </div>
    <div class="settings-group" ng-if="ctrl.valueFormula != null && ctrl.trendFormula != null">
      <h3 class="setting-title">Indicator</h3>
      <text-format-panel
        field-type="'${DataType.Name.Decimal}'"
        text-format="ctrl.trendTextFormat"
        chart-service="ctrl.chartService"
        format-changed="ctrl.updateTrendFormat($format)"
        hide-disabled="true"
      ></text-format-panel>
      <div class="form-field">
        <label class="axis-label">Description</label>
        <input type="text"
                class="form-control form-control-sm axis-title-input"
                ng-model-options="{ updateOn: 'blur' }"
                ng-model="ctrl.trendLabel"
                ng-change="ctrl.updateTrendLabel()"
                mode-enter />
      </div>
    </div>
`,
};
